import { DomainReference } from '@rygen/rygen-ui/model';

import { ShipmentStopType } from './shipment';
import { ShipOrderLineItem } from './ShipOrderLineItem';
import { ShipOrderShippingPoint } from './ShipOrderShippingPoint';

export class ShipOrder {
  id?: number;
  orderId?: number;
  shipmentId?: number;
  owner?: DomainReference;
  swc: boolean = false;
  customerRouted: boolean = false;
  lineItems: ShipOrderLineItem[] = [];
  origin: ShipOrderShippingPoint = new ShipOrderShippingPoint({
    shippingPointType: ShipmentStopType.PICKUP,
  });
  destination: ShipOrderShippingPoint = new ShipOrderShippingPoint({
    shippingPointType: ShipmentStopType.DROP_OFF,
  });
  tags: string[] = [];

  constructor(opts?: Partial<ShipOrder>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.orderId != null) {
      this.orderId = opts.orderId;
    }
    if (opts?.shipmentId != null) {
      this.shipmentId = opts.shipmentId;
    }
    if (opts?.owner != null) {
      this.owner = new DomainReference(opts.owner);
    }
    if (opts?.swc != null) {
      this.swc = opts.swc;
    }
    if (opts?.customerRouted != null) {
      this.customerRouted = opts.customerRouted;
    }
    if (opts?.lineItems != null) {
      this.lineItems = opts.lineItems.map(
        (val: ShipOrderLineItem) => new ShipOrderLineItem(val),
      );
    }
    if (opts?.origin != null) {
      this.origin = new ShipOrderShippingPoint(opts.origin);
    }
    if (opts?.destination != null) {
      this.destination = new ShipOrderShippingPoint(opts.destination);
    }
    if (opts?.tags != null) {
      this.tags = opts.tags;
    }
  }

  get compositeId(): string {
    return `${this.orderId} - ${this.id}`;
  }

  get stops(): [
    origin: ShipOrderShippingPoint,
    destination: ShipOrderShippingPoint,
  ] {
    return [this.origin, this.destination];
  }
}
